import React, { useState, useMemo } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import termsHistoryStyles from "./termsHistoryStyles";
import styles from "./TermsAndConditionsHistory.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { withTranslation } from "react-i18next";
import ConfirmDialog from "../../../shared/confirmDialog/ConfirmDialog";
import crStyles from "../../customerReservation/crStyles";
import HasPermissionTo from "../../../common/HasPermissionTo";
import DownloadButton from "../../../shared/buttons/DownloadButton";

const TermsAndConditionsHistory = (props) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [versionToDelete, setVersionToDelete] = useState(null);

  const deleteTermsDialogProps = useMemo(
    () => ({
      title: props.t("TermsandConditionsHistory.deleteTitle"),
      bodyText: props.t("TermsandConditionsHistory.deleteBody"),
      confirm: props.t("TermsandConditionsHistory.confirm"),
      cancel: props.t("TermsandConditionsHistory.cancel"),
    }),
    [props]
  );

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleConfirm = () => {
    props.deleteTerms(versionToDelete);
    handleClose();
  };

  const deleteTermsDialog = (version) => {
    setVersionToDelete(version);
    setOpenDialog(true);
  };

  const loadTableCellHeader = (style, divStyle, column, displayColumn) => {
    return (
      <TableCell style={style}>
        {displayColumn && (
          <div className={divStyle} id="header">
            {props.t("TermsandConditionsHistory." + column)}
          </div>
        )}
      </TableCell>
    );
  };

  const showDeleteIcon = (index) => {
    return (
      props.termsAndConditionsHistory.length > 1 &&
      index === 0 &&
      props.termsAndConditionsHistory[0].canBeDeleted
    );
  };

  return (
    <div className={styles.title}>
      <h2 className="pagePaddingLeft" id="termsHeader">
        {props.t("TermsandConditionsHistory.title")}
      </h2>
      <Table id="termsHistory">
        <TableHead>
          <TableRow
            style={termsHistoryStyles.tableRow}
            className={styles.tableHeader}
          >
            {loadTableCellHeader(
              termsHistoryStyles.documentHeader,
              styles.alignStart,
              "document",
              true
            )}
            {props.isDealer &&
              loadTableCellHeader(
                termsHistoryStyles.effectiveDateHeader,
                styles.alignCenter,
                "acceptedOn",
                true
              )}
            {loadTableCellHeader(
              termsHistoryStyles.effectiveDateHeader,
              styles.alignCenter,
              "effectiveFrom",
              true
            )}
            {loadTableCellHeader(
              termsHistoryStyles.downloadHeader,
              null,
              "download",
              false
            )}
            {!props.isDealer && loadTableCellHeader(null, null, null, false)}
          </TableRow>
        </TableHead>

        <ConfirmDialog
          open={openDialog}
          dialogProps={deleteTermsDialogProps}
          onConfirm={handleConfirm}
          onCancel={handleClose}
          onClose={handleClose}
          boldTitle={false}
          {...props}
        />

        <TableBody className={styles.tableBody}>
          {props.termsAndConditionsHistory.map((termsAndConditions, index) => (
            <TableRow
              className="pagePaddingLeft pagePaddingRight"
              id={`row_${index}`}
              key={index}
            >
              <TableCell style={termsHistoryStyles.document}>
                {props.user.market.toUpperCase() +
                  " " +
                  props.t("TermsandConditionsHistory.documentName") +
                  termsAndConditions.version}
              </TableCell>
              {props.isDealer && (
                <TableCell style={termsHistoryStyles.effectiveDate}>
                  {termsAndConditions.accepted
                    ? termsAndConditions.dealerApprovedDate
                    : "--"}
                </TableCell>
              )}
              <TableCell style={termsHistoryStyles.effectiveDate}>
                {termsAndConditions.effectiveDate}
              </TableCell>
              <TableCell style={termsHistoryStyles.download}>
                <div>
                  <span>
                    {termsAndConditions.accepted ? (
                      <DownloadButton
                        download={() =>
                          termsAndConditions.accepted &&
                          props.handleTermsAndConditionsDownload(
                            termsAndConditions
                          )
                        }
                        text={props.t("TermsandConditionsHistory.download")}
                      />
                    ) : (
                      props.isDealer && (
                        <Button
                          onClick={() =>
                            props.alterComponentView(termsAndConditions)
                          }
                        >
                          <span
                            id={`acceptLink_${index}`}
                            className={styles.download}
                          >
                            {props.t("TermsandConditionsHistory.review")}
                          </span>
                          <ChevronRightIcon style={crStyles.viewIcon} />
                        </Button>
                      )
                    )}
                  </span>
                </div>
              </TableCell>
              {!props.isDealer && (
                <TableCell style={termsHistoryStyles.rightCell}>
                  <div className={styles.deleteWrapper}>
                    <DownloadButton
                      download={() =>
                        props.handleTermsAndConditionsDownload(
                          termsAndConditions
                        )
                      }
                      text={props.t("TermsandConditionsHistory.download")}
                    />
                    <HasPermissionTo
                      permissions={props.user.permissions.rolePermissions}
                      perform={["deleteTermsConditions"]}
                      condition={showDeleteIcon(index)}
                      render={() => (
                        <Button
                          style={termsHistoryStyles.button}
                          data-testid={"delete_" + index}
                          onClick={() =>
                            deleteTermsDialog(termsAndConditions.version)
                          }
                        >
                          <ClearIcon />
                        </Button>
                      )}
                    />
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default withTranslation("emp")(TermsAndConditionsHistory);
